import { call, select, takeEvery } from 'redux-saga/effects';
import { SET_PRODUCT_QUANTITY, SetProductQuantityAction } from 'app/store/actions';
import { cmsApiOnProductChangeSelector, selectedProductsSelector } from 'app/store/selectors';
import { StoreProductField } from 'app/models/types/store/product';

export function* onSetProductQuantityWorker() {
  const products: StoreProductField['types'] = yield select(selectedProductsSelector);

  const onProductChanged: ReturnType<typeof cmsApiOnProductChangeSelector> = yield select(
    cmsApiOnProductChangeSelector,
  );

  yield call(onProductChanged, products);
}

export function* onSetProductQuantity() {
  yield takeEvery<SetProductQuantityAction>(SET_PRODUCT_QUANTITY, onSetProductQuantityWorker);
}
